import { API_AUTH_LOGIN_SUCCESS } from '@/actions/AuthActionsTs';
import { singletonScriptState } from '@/utils/window/SingletonScriptState';
import { AUTH_LOGIN_PURGE } from '../actions/AuthActions';
import { API_CREATE_POPUP_READ } from '../actions/PopupActions';
import { API_GET_ONE_PROFILE_SUCCESS, API_UPDATE_PROFILE_SUCCESS, } from '../actions/ProfileActions';
import GoogleAnalytics from '../vendor/GoogleAnalytics';
/** プロフィールの初期値はScriptタグから読み込む */
const INITIAL_STATE = singletonScriptState.profile.value || {};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, type }) => {
    switch (type) {
        // ログイン後のプロフィール情報取得
        case API_AUTH_LOGIN_SUCCESS: {
            const { profile } = payload;
            GoogleAnalytics.setProfileDataLayer(profile);
            return Object.assign({}, profile);
        }
        // ログイン後リロードなどのプロフィールの取得・更新後のデータ反映
        case API_GET_ONE_PROFILE_SUCCESS:
        case API_UPDATE_PROFILE_SUCCESS: {
            GoogleAnalytics.setProfileDataLayer(payload);
            return Object.assign({}, payload);
        }
        case API_CREATE_POPUP_READ: {
            const { event } = meta;
            return Object.assign(Object.assign({}, state), { viewPopups: (payload.viewPopups || []).filter((v) => v !== event) });
        }
        case AUTH_LOGIN_PURGE: {
            return {};
        }
        default: {
            return state;
        }
    }
};
